import React, { createContext, useCallback, useMemo } from "react";
import { useLocalStorage } from "../../hooks/useLocalStorage";

const ColorModeContext = createContext({
	mode: "light",
	toggleColorMode: () => {},
	setColorMode: () => {},
});

const ColorModeProvider = ({ children }) => {
	const [mode, setMode] = useLocalStorage("colorMode", "light");

	const toggleColorMode = useCallback(() => {
		setMode(prev => (prev === "dark" ? "light" : "dark"));
	}, [setMode]);

	const setColorMode = useCallback(
		value => {
			setMode(value === "dark" ? "dark" : "light");
		},
		[setMode]
	);

	const value = useMemo(
		() => ({
			mode: mode === "dark" ? "dark" : "light",
			toggleColorMode,
			setColorMode,
		}),
		[mode, toggleColorMode, setColorMode]
	);

	return (
		<ColorModeContext.Provider value={value}>
			{children}
		</ColorModeContext.Provider>
	);
};

export { ColorModeContext, ColorModeProvider };
